import React, { useEffect } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { NextUIProvider } from "@nextui-org/react";
import HomePage from "./pages/HomePage";
import RequestDemoPage from "./pages/RequestDemoPage";
import GeneratePage from "./pages/GeneratePage";
import LoginPage from "./pages/LoginPage";
import ProtectedRoute from "./features/auth/ProtectedRoute";

const App = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Regular expression to check if the path starts with "/generate/model"
    const pattern = /^\/generate\/model(?:\/|$)/;

    // Apply 'overflow: hidden' to fix image upload layout issues in GenerateSettingView
    if (pattern.test(location.pathname)) {
      document.body.style.overflow = "hidden";
    } else {
      // Revert overflow to normal for other pages
      document.body.style.overflow = "auto";
    }
  }, [location]);

  return (
    <NextUIProvider className="min-w-[1024px] antialiased  before:absolute before:bottom-0 before:left-0 before:right-0 before:top-0 before:-z-50 before:bg-dark-bg" navigate={navigate}>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/request-demo" element={<RequestDemoPage />} />
        <Route
          path="/generate/*"
          element={
            <ProtectedRoute>
              <GeneratePage />
            </ProtectedRoute>
          }
        />
        <Route path="/login" element={<LoginPage />} />
      </Routes>
    </NextUIProvider>
  );
};

export default App;
